import React from "react";

export const DocumentVerification = (props) => {
  return (
    <svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g id="Document-verification">
        <path
          id="Rectangle 1"
          d="M16.1394 0.94812H2.14642C1.41942 0.94812 0.830078 1.62151 0.830078 2.45218V13.5652C0.830078 14.3959 1.41942 15.0693 2.14642 15.0693H16.1394C16.8664 15.0693 17.4557 14.3959 17.4557 13.5652V2.45218C17.4557 1.62151 16.8664 0.94812 16.1394 0.94812Z"
          stroke="#4BCFFF"
          strokeWidth={2}
        />
        <path
          id="Line 1"
          d="M10.5823 6.0155H14.6334"
          stroke="#4BCFFF"
          strokeWidth={2}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          id="Line 2"
          d="M10.5823 8.80127H14.6334"
          stroke="#4BCFFF"
          strokeWidth={2}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          id="Ellipse 1"
          d="M5.9029 7.44037C6.69132 7.44037 7.33046 6.71009 7.33046 5.80924C7.33046 4.90839 6.69132 4.1781 5.9029 4.1781C5.11448 4.1781 4.47534 4.90839 4.47534 5.80924C4.47534 6.71009 5.11448 7.44037 5.9029 7.44037Z"
          stroke="#4BCFFF"
          strokeWidth={2}
        />
        <path
          id="Path 1"
          d="M8.75833 11.5192V12.4675C8.97845 12.4675 9.18956 12.3676 9.34521 12.1898C9.50086 12.0119 9.5883 11.7707 9.5883 11.5192H8.75833ZM3.04768 11.5192H2.2177C2.2177 11.7707 2.30514 12.0119 2.46079 12.1898C2.61645 12.3676 2.82755 12.4675 3.04768 12.4675V11.5192ZM8.75833 11.5192V10.5708H5.90279V12.4675H8.75833V11.5192ZM5.90279 10.5708H3.04768V12.4675H5.90279V10.5708ZM3.87724 11.5192C3.89672 11.4226 3.93191 11.3311 3.98098 11.2494C4.10004 11.0345 4.24808 10.8424 4.41963 10.6804C4.83129 10.2685 5.35584 10.0338 5.90279 10.0165V8.11987C4.9636 8.13609 4.05925 8.5288 3.34771 9.22942C3.03958 9.52303 2.77452 9.87104 2.56256 10.2603C2.35021 10.6352 2.23088 11.069 2.21729 11.5154L3.87724 11.5192ZM5.90279 10.0203C6.44976 10.0375 6.97432 10.2723 7.38596 10.6842C7.55751 10.8462 7.70556 11.0383 7.8246 11.2532C7.8737 11.3349 7.90889 11.4264 7.92835 11.523H9.5883C9.5747 11.0766 9.45538 10.6428 9.24303 10.2679C9.03108 9.87861 8.76601 9.5306 8.45787 9.23701C7.74633 8.53639 6.84198 8.14367 5.90279 8.12746V10.0203Z"
          fill="#4BCFFF"
        />
        <path
          id="Path 2"
          d="M23.1692 16.8968C23.1692 15.6796 22.8532 14.4898 22.2613 13.4778C21.6694 12.4658 20.8281 11.677 19.8439 11.2113C18.8597 10.7456 17.7767 10.6238 16.7319 10.8614C15.6871 11.0989 14.7274 11.6852 13.9742 12.5459C13.221 13.4067 12.7081 14.5033 12.5004 15.6971C12.2926 16.8909 12.3994 18.1283 12.8071 19.2528C13.2149 20.3773 13.9053 21.3384 14.7911 22.0146C15.6769 22.6907 16.7182 23.0516 17.7835 23.0515C19.2117 23.0504 20.5812 22.4015 21.591 21.2475C22.6008 20.0935 23.1685 18.5287 23.1692 16.8968Z"
          fill="white"
          stroke="#3377FF"
          strokeWidth={2}
        />
        <path
          id="Path 3"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M14.801 17.8925L16.5617 19.9039C16.6311 19.9834 16.7136 20.0466 16.8044 20.0897C16.8952 20.1327 16.9925 20.1549 17.0909 20.1549C17.1892 20.1549 17.2865 20.1327 17.3773 20.0897C17.4681 20.0466 17.5506 19.9834 17.62 19.9039L21.1411 15.8806C21.2815 15.7202 21.3603 15.5028 21.3603 15.276C21.3603 15.0492 21.2815 14.8318 21.1411 14.6714C21.0008 14.5111 20.8105 14.421 20.612 14.421C20.4136 14.421 20.2232 14.5111 20.0829 14.6714L17.0909 18.0902L15.8592 16.6829C15.7188 16.5225 15.5285 16.4324 15.3301 16.4324C15.1316 16.4324 14.9413 16.5225 14.801 16.6829C14.6606 16.8432 14.5818 17.0607 14.5818 17.2874C14.5818 17.5142 14.6606 17.7321 14.801 17.8925Z"
          fill="#3377FF"
        />
      </g>
    </svg>
  );
};
